module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "online-roundtable-prompt start-xs",
    domProps: {
      "innerHTML": _vm._s(_vm.prompt_adjusted_with_links)
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-6e6b6838!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/onlineRoundtables/components/promptInSubmitPage.vue
// module id = 1383
// module chunks = 61